// extracted by mini-css-extract-plugin
module.exports = {"normal":"Item_normal__23hUa","linkOpen":"Item_linkOpen__1JUqk"};